import script from "./SALStep5Confirmacion.vue?vue&type=script&setup=true&lang=js"
export * from "./SALStep5Confirmacion.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__